import React, { Component } from 'react';
import css from './SetPassword.module.scss';
import Input from '../../../components/UI/CustomInputField';
import WidgetPropTypes from '../types';
import WidgetPagePropTypes from '../../WidgetPage/types';
import PasswordValidation from '../../../components/UI/PasswordValidation/index.tsx';

export const WIDGET_NAME = 'set_user_password';

class SetPassword extends Component {
  state = {
    password: '',
    error: false,
    typingPassword: false,
    passwordTooShort: true,
    passwordRequiresLetter: true,
    passwordRequiresNumber: true
  };

  componentDidMount() {
    this.props.analytics.trackEvent('Registration Enter Password Viewed', {
      eventProps: {
        role: this.props.app.answers.setRole
      }
    });
  }

  isValidLength = value => value.length > 7;

  onChange = which => value => {
    const match = value.match(/^(?=.*\d)(?=.*[A-Za-z])[\S]{8,}$/);
    if (this.state.typingPassword === false) {
      this.setState({
        typingPassword: true
      });
    }
    if (this.isValidLength(value)) {
      this.setState({
        passwordTooShort: false
      });
    } else {
      this.setState({
        passwordTooShort: true
      });
    }
    if (/[a-zA-Z]/.test(value)) {
      this.setState({
        passwordRequiresLetter: false
      });
    } else {
      this.setState({
        passwordRequiresLetter: true
      });
    }
    if (/\d/.test(value)) {
      this.setState({
        passwordRequiresNumber: false
      });
    } else {
      this.setState({
        passwordRequiresNumber: true
      });
    }
    this.setState({
      [which]: value,
      valid: match != null && match.length > 0
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { widget, shouldEnable } = this.props;
    if (prevState.password !== this.state.password) {
      shouldEnable(widget, this.isValidLength(this.state.password));
    }
  }

  errorChecking = async () => {
    if (!/^(?=.*[A-Za-z])(?=.*\d)(.*){8,}$/.test(this.state.password)) {
      this.setState({ error: true });
      throw new Error();
    }
  };

  render() {
    const { changeAnswerValue, widget } = this.props;

    return (
      <div style={{ marginBottom: '20px' }}>
        <div className={css.passwordInputField}>
          <Input
            id="passwordId"
            placeholder="Create password"
            error={this.state.error}
            onClick={this.props.onClick}
            type="password"
            autoComplete="off"
            autoCorrect="off"
            passwordEyeball={true}
            format={
              !this.state.typingPassword
                ? `Must be 8+ characters and at least 1 number`
                : ''
            }
            onChange={value => {
              this.onChange('password')(value.trim());
              changeAnswerValue(widget, value.trim());
            }}
            className="ParentInfo2-Custom-Input fs-mask"
            data-e2e="password"
          />
        </div>
        {this.state.typingPassword && (
          <div className={css.passwordValidation}>
            <PasswordValidation
              isValid={!this.state.passwordTooShort}
              isError={!!this.state.error}
              label="Must be 8+ characters"
              dataTestIdFailed="password-too-short"
              dataTestIdPassed="password-long-enough"
            />
            <PasswordValidation
              isValid={!this.state.passwordRequiresLetter}
              isError={!!this.state.error}
              label="Must contain at least one letter"
              dataTestIdFailed="password-no-letter"
              dataTestIdPassed="password-contains-letter"
            />

            <PasswordValidation
              isValid={!this.state.passwordRequiresNumber}
              isError={!!this.state.error}
              label="Must contain at least one number"
              dataTestIdFailed="password-no-number"
              dataTestIdPassed="password-contains-number"
            />
          </div>
        )}
      </div>
    );
  }
}

SetPassword.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired,
  app: WidgetPagePropTypes.app
};

export default SetPassword;
